module.exports = __webpack_public_path__ + "static/media/subcribe.4282f864.svg";